import {AgentNewsFilter, EmptyAgentNewsFilter} from 'AgentNewsAdministration/models/AgentNewsFilter';
import {AsyncPage, Empty, Loading, LoadingAdditional} from 'Core/models/Async';
import {Page} from 'Core/models/Page';
import {createAction} from 'Shared/utilities/actionCreator';
import {NewsEntryDto} from 'AgentNewsAdministration/models/Dtos/AgentNewsEntry';

export enum AgentNewsActionType {
  GET_NEWS = 'news/GET_NEWS',
  DELETE_NEWS_ENTRY = 'news/DELETE_NEWS_ENTRY',
  CHANGE_NEWS_FILTER = 'news/CHANGE_NEWS_FILTER',
  CHANGE_NEWS = 'news/CHANGE_NEWS',
  CLEAR = 'news/CLEAR',
}

export const newsApiLink = '/api/agent/v1/news';

export const getNews = (page?: Page<NewsEntryDto>, filter?: AgentNewsFilter) =>
  createAction(AgentNewsActionType.GET_NEWS, {page, filter});
export const deleteNewsEntry = (id: string) => createAction(AgentNewsActionType.DELETE_NEWS_ENTRY, {id});
export const changeNews = (news: AsyncPage<Page<NewsEntryDto>>) =>
  createAction(AgentNewsActionType.CHANGE_NEWS, {news});
export const changeNewsFilter = (filter: AgentNewsFilter) =>
  createAction(AgentNewsActionType.CHANGE_NEWS_FILTER, {filter});
export const clearNewsFilter = () =>
  createAction(AgentNewsActionType.CHANGE_NEWS_FILTER, {filter: DEFAULT_STATE.filter});
export const clearNews = () => createAction(AgentNewsActionType.CLEAR);

export type AgentNewsState = {
  news: AsyncPage<Page<NewsEntryDto>>;
  filter: AgentNewsFilter;
};

export const DEFAULT_STATE : AgentNewsState = {
  news: new Empty(),
  filter: EmptyAgentNewsFilter,
};

type AgentNewsAction =
  | ReturnType<typeof changeNewsFilter>
  | ReturnType<typeof getNews>
  | ReturnType<typeof changeNews>
  | ReturnType<typeof clearNews>;

export default (
    state: AgentNewsState = DEFAULT_STATE, 
    action: AgentNewsAction
  ): AgentNewsState => {
  switch (action.type) {
    case AgentNewsActionType.CHANGE_NEWS_FILTER:
      return {
        ...state,
        filter: action.payload.filter,
      };
    case AgentNewsActionType.GET_NEWS:
      return {
        ...state,
        news: action.payload.page ? new LoadingAdditional(action.payload.page) : new Loading(),
      };
    case AgentNewsActionType.CHANGE_NEWS:
      const {news} = action.payload;
      return {
        ...state,
        news,
      };
    case AgentNewsActionType.CLEAR:
      return DEFAULT_STATE;
    default:
      return state;
  }
};
